import { contentManagementUrl, contentToken } from "../constants/environmentSettings";

export const CONTENT_URL = contentManagementUrl;
export const CONTENT_TOKEN = contentToken;
export const BANNER_CONTENT = "/api/banner-messages?populate=*";